<template>
  <!-- 通知详情页 -->
  <div class="Informdetails">
    <div class="Informdetails-own">
      <div class="left">
        <div class="seat">
          当前前位置: <span @click="homes()">首页 </span> >
          <span @click="myinformation">
            {{ this.$store.state.tzzx }}
          </span>
          >文章详情
        </div>
        <h6>{{ datas.name }}</h6>
        <div v-if="$store.state.tzzx !== '任务发布'" class="Thedateof">
          {{ datas.putime }}
        </div>
        <div v-else class="Thedateof">{{ datas.taskfbdate }}</div>
        <div align="justify" class="info-content" v-html="datas.content"></div>
        <div>
          <el-button
            v-show="$store.state.tzzx == '任务发布' && !dataRw"
            type="primary"
            :round="true"
            @click="Pickup"
            >领取任务上传</el-button
          >
          <el-button
            v-show="
              $store.state.tzzx == '任务发布' &&
              dataRw &&
              this.$store.state.usert.dentity.includes('医生')
            "
            type="primary"
            :round="true"
            @click="PickupGo"
            >已领取任务点击去编写</el-button
          >
        </div>

        <Sharehomepage></Sharehomepage>
      </div>

      <div class="right">
        <Rankingpage
          v-bind:dat="templ"
          v-on:parameters="Passingparameters"
        ></Rankingpage>
      </div>
    </div>
    <div v-if="tableData.length !== 0" class="rwsc">
      该任务上传列表({{ tableData.length }})
    </div>
    <div class="buttom">
      <ul class="Course">
        <li
          class="Live1"
          v-for="(iten, index) in tableData"
          :key="index"
          @click="jump(iten)"
        >
          <video
            v-if="iten.sorts == '视频'"
            :poster="iten.picture ? iten.picture : commonIMG"
            class="videois"
            @click="jump(iten)"
            :src="htto + iten.video"
          ></video>
          <el-image
            v-else
            class="videois"
            :src="iten.picture ? iten.picture : commonIMG"
          />
          <i
            v-if="iten.sorts == '视频'"
            class="el-icon-video-play"
            style="
              font-size: 60px;
              position: absolute;
              margin-left: 100px;
              margin-top: 65px;
              color: #ffffff;
              opacity: 0.5;
            "
          ></i>
          <div class="thevideo">
            <div style="display: flex">
              <div class="thename" @click="jump(iten)">
                {{ iten.name }}
              </div>
              <i
                class="el-icon-star-on"
                style="color: #f86626; font-size: 18px"
              >
                {{ iten.score ? iten.score : 0 }}</i
              >
            </div>
            <p class="wb" @click="jump(iten)" v-html="iten.content"></p>

            <div class="collection">
              <span class="dzs" @click="eacherpage(iten.user.id)"
                ><img class="imgssz" :src="htto + iten.user.tx" alt="" />{{
                  iten.user.name
                }}</span
              >
              <div class="jejq">
                <!-- <span class="je">{{ iten.jg }}</span> -->
                <div v-if="radio4 === '浏览' || radio4 === '默认'">
                  <i
                    style="font-size: 14px; color: #999999; line-height: 20px"
                    class="iconfont gos-yanjing1"
                  ></i>
                  <p class="dzs">浏览量：{{ iten.ll }}</p>
                </div>
                <div v-if="radio4 === '收藏'">
                  <i
                    style="font-size: 14px; color: #999999; line-height: 20px"
                    class="iconfont gos-aixin"
                  ></i>
                  <p class="dzs">收藏：{{ iten.sc }}</p>
                </div>
                <div v-if="radio4 === '最新' || radio4 === '最新倒'">
                  <p class="dzs">{{ iten.knowdate }}</p>
                </div>
                <div v-if="radio4 === '点赞'">
                  <p class="dzs">点赞量：{{ iten.dz }}</p>
                </div>
                <div v-if="radio4 === '评分'">
                  <el-rate disabled v-model.number="iten.score"></el-rate>
                </div>
              </div>
              <!-- <button
                    v-if="iten.jg !== '免费'"
                    @click="jump(iten)"
                    class="Buynow"
                  >
                    立即购买
                  </button>
                  <button
                    v-if="iten.jg == '免费'"
                    @click="jump(iten)"
                    class="Buynow"
                  >
                    立即查看
                  </button> -->
            </div>
          </div>
        </li>
      </ul>
      <el-pagination
        v-if="this.paging.total !== 0"
        @current-change="handleCurrentChange"
        :page-size="paging.rows"
        background
        prev-text="上一页"
        next-text="下一页"
        layout="prev, pager, next"
        :total="paging.total"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import Rankingpage from "../Rankingpage/Rankingpage.vue";
import Sharehomepage from "../Sharehomepage/Sharehomepage.vue";
import {
  selpublic,
  selpublictj,
  seltask,
  instaskuser,
  seltaskuser,
  selknow,
} from "../../api/patient";
import Bus from "@/utils/bus";
export default {
  data() {
    return {
      datas: "",
      templ: {},
      vaues: "",
      pager: 1,
      rows: 10,
      dataRw: false,
      tableData: {},
      commonIMG: require("../../assets/common/jkkp.png"),
      htto: this.$store.state.https,
      paging: {
        page: 1,
        rows: 6,
        total: 0,
      },
    };
  },
  created() {
    this.selpublics();
    this.sellists();
    this.selitemis();
  },
  mounted() {
    Bus.$emit("activeRouter", "/home");
  },
  methods: {
    // 课程列表
    async selitemis(item) {
      var data = new FormData();
      data.append("page", this.paging.page);
      data.append("rows", this.paging.rows);
      data.append("tid", this.$route.params.id);
      data.append("status", "已通过");
      var res = await selknow(data);
      this.tableData = res.records;
      this.paging.total = res.totalCount;
      for (let i = 0; i < this.tableData.length; i++) {
        if (this.tableData[i].sorts == "视频") {
          this.tableData[i].picture = this.htto + this.tableData[i].picture;
        }
      }
    },
    //去编写
    PickupGo() {
      this.$router.push(`/UploadPopular/${this.$route.params.id}`);
    },
    //领取任务
    Pickup() {
      if (this.$store.state.isLogin) {
        var data = new FormData();
        data.append("phone", this.$store.state.user.phone);
        data.append("tid", this.$route.params.id);
        data.append("status", "已接取");
        instaskuser(data).then((res) => {
          if (res.code == "OK") {
            this.$router.push(`/UploadPopular/${this.$route.params.id}`);
            this.$message({
              showClose: true,
              message: "领取任务成功，请编写并上传",
              type: "success",
            });
          } else {
            this.$message({
              showClose: true,
              message: "领取失败",
              type: "error",
            });
          }
        });
      } else {
        this.$message({
          showClose: true,
          message: "请先进行登录",
          type: "warning",
        });
      }
    },
    homes() {
      this.$router.push("/home");
    },
    myinformation() {
      if (this.$store.state.tzzx === "通知公告") {
        this.$router.push(`/Newslist/${this.$store.state.tzzx}`);
      } else {
        this.$router.push(`/Newslist/${this.$store.state.tzzx}`);
      }
    },
    Passingparameters(item) {
      this.datas = item;
    },
    // 获取通过路由传参
    selpublics() {
      var data = new FormData();
      data.append("id", this.$route.params.id);
      if (this.$store.state.tzzx === "任务发布") {
        seltask(data).then((res) => {
          this.datas = res;
          this.Newslists();
        });
      } else {
        selpublic(data).then((res) => {
          this.datas = res;
          this.selpublica();
        });
      }
    },
    // 获取任务列表
    sellists() {
      var data = new FormData();
      data.append("page", 1);
      data.append("rows", 10);
      data.append("phone", this.$store.state.user.phone);
      data.append("tid", this.$route.params.id);
      seltaskuser(data).then((res) => {
        if (
          res.records[0].status == "已接取" ||
          res.records[0].status == "已提交"
        ) {
          this.dataRw = true;
        }
      });
    },
    // 获取任务发布
    Newslists() {
      var data = new FormData();
      data.append("page", this.pager);
      data.append("rows", this.rows);
      seltask(data).then((res) => {
        this.templ = res.records;
      });
    },
    selpublica() {
      var data = new FormData();
      data.append("mkpublic", this.datas.mkpublic);
      selpublictj(data).then((res) => {
        this.templ = res;
      });
    },
  },
  // destroyed() {
  //   this.$store.commit("zxxixvt", "");
  // },
  components: {
    Rankingpage,
    Sharehomepage,
  },
};
</script>
<style scoped>
.info-content {
  width: 659px;
  word-wrap: break-word;
  min-height: 700px;
  margin-top: 23px;
  max-width: 669px;
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #333333;
  line-height: 25px;
  overflow: hidden;
}
</style>
<style scoped lang="scss">
.Informdetails {
  width: 100%;
  margin-top: 9px;
  background: #f8fafc;
  .Informdetails-own {
    display: flex;
    width: 1042px;
    margin: auto;
    background: #fff;
    padding-bottom: 80px;
    .left {
      width: 689px;
      padding-left: 30px;
      padding-top: 21px;
      position: relative;
      .seat {
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #000;
        text-align: left;
        cursor: pointer;
      }
      h6 {
        margin-top: 20px;
        text-align: left;
        font-size: 30px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #333333;
      }
      .Thedateof {
        margin-top: 10px;
        text-align: left;
        font-size: 12px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #333333;
      }
      p {
        display: flex;
        flex-wrap: wrap;
        min-height: 700px;
        margin-top: 23px;
        max-width: 669px;
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #333333;
        line-height: 25px;
      }
    }

    .right {
      width: 343px;
      height: 100%;
      // background: salmon;
    }
  }
}
.Sharehomepage {
  position: absolute;
  right: -60px;
  bottom: 100px;
}
.rwsc {
  width: 1002px;
  font-family: Source Han Sans CN;
  font-weight: bold;
  font-size: 22px;
  color: #333333;
  margin: auto;
  text-align: left;
  background-color: #ffffff;
  padding: 20px;
}
.buttom {
  margin-top: 27px;
  width: 1042px;
  margin: auto;

  .Course {
    display: flex;
    width: 100%;
    justify-content: left;
    flex-wrap: wrap;
    .Live1 {
      display: flex;
      width: 1042px;
      height: 190px;

      background: #ffffff;
      border: 1px solid #f6f6f6;
      border-radius: 10px;
      margin-bottom: 10px;
      transition: all 0.2s;
      // margin-left: 17px;
      .thevideo {
        width: 800px;
        display: flex;
        flex-direction: column;
        padding: 20px 20px 20px 0px;
        .thename {
          overflow-x: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          font-size: 15px;
          width: 700px;
          font-weight: bold;
          text-align: left;
        }
        .wb {
          display: flex;
          text-align: left;
          margin-top: 10px;
          // width: 777px;
          height: 80px;
          cursor: pointer;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #999999;
          display: -webkit-box; /**对象作为伸缩盒子模型展示**/
          -webkit-box-orient: vertical; /**设置或检索伸缩盒子对象的子元素的排列方式**/
          -webkit-line-clamp: 3; /**显示的行数**/
          overflow: hidden; /**隐藏超出的内容**/
          font-size: 12px;
          line-height: 26px;
        }

        .collection {
          padding-top: 8px;
          margin-top: 5px;
          display: flex;
          justify-content: space-between;
          // border-top: 2px solid #f6f6f6;
          .jejq {
            margin-top: 3px;
            display: flex;
            justify-content: space-between;
            .je {
              // width: 66px;
              font-size: 12px;
              font-family: Source Han Sans CN;
              font-weight: bold;
              color: #ff1616;
            }
            div {
              display: flex;
              img {
                width: 12px;
                height: 12px;
                line-height: 12px;
                margin-right: 8px;
                padding-top: 2px;
              }
              .dzs {
                font-size: 12px;
                margin-left: 5px;
                font-family: Source Han Sans CN;
                font-weight: 400;
                color: #999999;
              }
            }
          }
          .dzs {
            cursor: pointer;
            white-space: nowrap;
            // height: 13px;
            font-size: 12px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #999;
          }
          .Buynow {
            cursor: pointer;
            white-space: nowrap;
            // display: flex;
            text-align: center;
            width: 67px;
            height: 23px;
            background: #4ccaff;
            border-radius: 4px;
            border: 1px;
            font-size: 12px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #ffffff;
          }
          .Buynow:hover {
            background: #4ccaffc9;
          }
        }
      }
    }
    .Live1:hover {
      transform: translateY(-2px);
      box-shadow: 0 12px 20px 0 rgba(95, 101, 105, 0.15);
    }
  }
  .el-pagination {
    margin-top: 60px;
    margin-bottom: 30px;
  }
}
.videois {
  width: 247px;
  height: 151px;
  padding: 20px 20px;
  border-radius: 6px 6px 0px 0px;
  object-fit: contain;
}
.imgssz {
  cursor: pointer;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  margin-right: 10px;
}
// 适配手机端
@media (max-width: 768px) {
  .info-content {
    width: 90vw;
    padding: 5px;
  }
  .Informdetails {
    .Informdetails-own {
      display: block;
      width: 95vw;
      .left {
        width: 95vw;
        padding-left: 0px;
        p {
          width: 90vw;
        }
      }

      .right {
        width: 95vw;
        height: 100%;
        // background: salmon;
      }
    }
  }
  .Sharehomepage {
    display: none;
  }
  .rwsc {
    width: 90vw;
    padding: 10px;
  }
  .buttom {
    margin-top: 27px;
    width: 95vw;
    margin: auto;

    .Course {
      display: flex;
      width: 100%;
      justify-content: left;
      flex-wrap: wrap;
      .Live1 {
        display: block;
        width: 95vw;
        height: 380px;
        .thevideo {
          width: 90vw;
          display: flex;
          flex-direction: column;
          padding: 0px 0px 10px 10px;
          .thename {
            width: 80vw;
          }
        }
      }
    }
  }
  .videois {
    width: 85vw;
    height: 181px;
    padding: 20px 20px;
    border-radius: 6px 6px 0px 0px;
    object-fit: contain;
  }
  .imgssz {
    cursor: pointer;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    margin-right: 10px;
  }
}
</style>
